var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGerm2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194.67 164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#95b13a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -199.9,
    y: -166.1,
    width: 325.86,
    height: 527.7,
    transform: "translate(-124.89 41.25) rotate(-77.99)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, -16.484, 20.652)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    transform: "translate(36.348 -28.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    className: "cls-3",
    d: "M70.48,139.17c-1.5-.32-2.92-.66-4.24-1-6.96-1.8-16.69-5.17-20.82-13.73-6.05-12.59-8.85-23.9-8.31-33.63,.3-5.32,2.97-11.73,5.57-17.93,1.57-3.46,2.89-7.04,3.95-10.69,4.46-18.72,32.07-33.37,48.38-34.86h0c9.66-.44,18.87,4.15,24.32,12.15,4.98,7.35,8.01,15.85,8.78,24.7,3,22.4-1.85,44.13-13.31,59.62-4.24,6.14-10.05,11.03-16.83,14.15-9.3,3.95-19.5,2.94-27.47,1.25m25.17-104.63c-14.09,1.28-38.45,14.46-42,29.33-1.14,4.04-2.58,7.99-4.32,11.81-2.4,4.91-4.08,10.13-5.01,15.51-.46,8.5,2.1,18.62,7.63,30.09,2.14,4.45,7.26,7.58,16.09,9.85,11.59,2.99,20.2,3.02,27.06,.1,5.58-2.63,10.36-6.7,13.84-11.79,10.35-13.99,14.71-33.81,11.95-54.36-.64-7.63-3.2-14.98-7.44-21.35-3.98-5.9-10.69-9.37-17.81-9.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    className: "cls-3",
    d: "M112.22,40.24c-.14-.03-.28-.07-.41-.11-1.89-.66-2.89-2.72-2.23-4.61h0c3.9-11.23,9.46-21.8,16.51-31.37,1.14-1.64,3.4-2.04,5.04-.9,1.64,1.14,2.04,3.4,.9,5.04-.03,.05-.07,.09-.1,.14-6.62,8.99-11.84,18.92-15.5,29.47-.6,1.74-2.41,2.75-4.2,2.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    className: "cls-3",
    d: "M124.78,68.55c-1.95-.44-3.19-2.37-2.75-4.33,.27-1.22,1.16-2.22,2.34-2.63,11.92-4.14,25.43-8.85,39.33-7.4,2,.15,3.49,1.89,3.34,3.89-.15,2-1.89,3.49-3.89,3.34-.07,0-.13-.01-.2-.02-12.3-1.28-24.99,3.14-36.2,7.04-.63,.22-1.31,.26-1.96,.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    className: "cls-3",
    d: "M128.32,98.02c-1.95-.44-3.18-2.38-2.74-4.33,.36-1.61,1.78-2.78,3.43-2.83,13.64-.39,27.24,1.66,40.16,6.05,1.88,.68,2.86,2.75,2.18,4.64-.66,1.84-2.66,2.82-4.51,2.23-12.11-4.13-24.85-6.05-37.64-5.69-.3,0-.6-.02-.89-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    className: "cls-3",
    d: "M26.71,143.18c-.26-.06-.51-.14-.75-.26-1.81-.85-2.59-3.01-1.74-4.82l14.25-30.49c.85-1.81,3-2.6,4.82-1.75,1.81,.85,2.6,3,1.75,4.82l-14.26,30.49c-.72,1.54-2.4,2.37-4.06,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    className: "cls-3",
    d: "M42.74,161.16c-1.96-.43-3.19-2.37-2.76-4.33,.05-.21,.11-.41,.19-.61,3.89-9.28,9.66-17.65,16.94-24.58,1.45-1.38,3.74-1.32,5.12,.13,1.38,1.45,1.32,3.74-.13,5.12-6.55,6.24-11.74,13.77-15.24,22.12-.68,1.62-2.41,2.52-4.12,2.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    className: "cls-3",
    d: "M110.32,52.01c-.97-.74-2.25-.91-3.37-.47-1.69,.54-3.22,1.48-4.47,2.74-1.35,1.15-2.37,2.65-2.95,4.33l-.27,1.18c-.23,1.1-.6,2.44,.3,3.38,.97,.74,2.25,.91,3.38,.47,1.69-.54,3.22-1.48,4.47-2.73,1.36-1.16,2.38-2.66,2.96-4.35l.25-1.18c.23-1.1,.6-2.44-.3-3.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    className: "cls-3",
    d: "M81.17,104.12c-4.55-1.01-16.86,5.5-9,7.24,4.54,1.01,16.86-5.5,9-7.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    className: "cls-3",
    d: "M82.37,93.87c-3.58-.75-6.99-2.14-10.06-4.11-3.27-1.75-5.57-4.88-6.27-8.52-.29-3.52,1.06-6.97,3.67-9.35,3.65-3.46,8.38-5.57,13.39-5.96,12.12-1.24,20.61,2.39,25.26,10.83,1.99,3.32,1.89,7.49-.24,10.73-1.03,1.33-2.34,2.42-3.83,3.19-6.68,3.67-14.46,4.8-21.91,3.18m10.15-20.44c-2.86-.54-5.79-.63-8.68-.28h0c-3.36,.22-6.54,1.58-9.02,3.85-.98,.82-1.56,2.02-1.61,3.29,.13,1.01,1.2,2.21,3.01,3.38,7.43,4.65,16.79,4.92,24.47,.71,.58-.29,1.1-.67,1.54-1.14,.43-.97,.34-2.09-.25-2.98-1.95-3.61-5.44-6.12-9.48-6.83m-9.05-3.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    className: "cls-3",
    d: "M80.75,52.9c-.01-.72-.61-1.29-1.33-1.28-.72,.01-1.29,.61-1.28,1.33-.14,1.71,2.71,1.68,2.59-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    className: "cls-3",
    d: "M67.03,72.47c.04-1.54-2.63-1.29-2.21,.41,.07,.38,.23,.74,.46,1.05,.25,.39,.77,.51,1.17,.26,.12-.08,.22-.19,.29-.31,.19-.44,.29-.92,.29-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    className: "cls-3",
    d: "M57.57,100.16c-.31-1.02-1.77-.51-1.54,.49,.52,3.49,1.51,6.89,2.92,10.12,.27,.51,1.04,.19,1.03-.33-.34-3.52-1.15-6.98-2.41-10.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    className: "cls-3",
    d: "M98.89,104.91c.07-.35-.15-.69-.49-.76s-.69,.15-.76,.49c-.49,1.69-.82,3.42-1,5.17,.04,.3,.31,.5,.61,.47,.16-.02,.3-.11,.39-.25,.57-1.66,.99-3.38,1.26-5.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    className: "cls-3",
    d: "M109.03,97.88c-.27,1.28-.54,2.56-.79,3.85-.07,.32,.14,.64,.46,.71s.64-.14,.71-.46h0c.32-1.26,.62-2.53,.89-3.81,.08-.35-.14-.69-.49-.77-.35-.08-.69,.14-.77,.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    className: "cls-3",
    d: "M82.51,98.52c-2.11-.88-4.27-1.65-6.46-2.31-.56-.19-.91,.77-.36,.99,2.09,.93,4.23,1.74,6.4,2.45,.33,.06,.65-.16,.71-.49,.05-.25-.07-.51-.29-.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    className: "cls-3",
    d: "M86.65,125.12c-2.14-.76-4.45-.88-6.65-.35-.39,.12-.41,.81,.04,.85,.96,.09,1.92-.02,2.88,.05,1.18,.08,2.31,.37,3.47,.57,.31,.07,.62-.13,.68-.44s-.13-.62-.44-.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    className: "cls-3",
    d: "M60.71,81.7c-.44-.1-.87,.18-.97,.61-.1,.44,.18,.87,.61,.97,.44,.1,.87-.18,.97-.61,.1-.44-.18-.87-.61-.97h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    className: "cls-3",
    d: "M70.91,54.87c-.04-.48-.45-.83-.93-.8-.29,.02-.55,.19-.69,.44-.29,.56-.36,1.21-.22,1.82,.14,.39,.56,.6,.96,.46,.12-.04,.22-.11,.3-.2,.39-.49,.6-1.1,.58-1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    className: "cls-3",
    d: "M91.76,43.02l-.06,.3c-.12,.54,.22,1.07,.76,1.19,.54,.12,1.07-.22,1.19-.76l.06-.3c.06-.55-.33-1.04-.88-1.11-.47-.05-.91,.23-1.06,.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    className: "cls-3",
    d: "M116.27,71.49c-.05-.72-.05-1.44-.01-2.16-.03-.33-.32-.56-.64-.53-.19,.02-.37,.13-.46,.3-.69,1.52-.54,3.3,.42,4.68,.32,.39,1.11,.29,1.04-.33s-.24-1.3-.34-1.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    className: "cls-3",
    d: "M92.92,119.29l-.15-.39c-.47-1.25-2.27-.12-1.34,.85l.28,.3c.31,.27,.77,.24,1.05-.06,.17-.19,.23-.46,.16-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    className: "cls-3",
    d: "M105.2,116.78c-.52-.09-1.01,.26-1.1,.78-.08,.48,.21,.95,.68,1.08,.52,.09,1.01-.26,1.1-.78,.08-.48-.21-.95-.68-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    className: "cls-3",
    d: "M65.47,121.62c-.5-.08-.97,.26-1.05,.76-.08,.46,.21,.91,.66,1.03,.5,.08,.97-.26,1.05-.76,.08-.46-.21-.91-.66-1.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    className: "cls-3",
    d: "M54.68,89.56c-.43-.43-.92-.81-1.44-1.14-.91-.65-1.77,.92-.81,1.54,.5,.34,1.04,.62,1.6,.84,.75,.27,1.07-.77,.65-1.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    className: "cls-3",
    d: "M113.68,87.89c-.4-.22-.86-.31-1.31-.24-.43,.04-.75,.43-.71,.86,.02,.25,.16,.47,.38,.6,.39,.26,.84,.38,1.31,.35,.46-.04,.8-.44,.76-.9-.02-.28-.19-.53-.43-.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    className: "cls-3",
    d: "M92.61,75.91c-1.36-.36-2.75-.63-4.13-.92-1.04-.17-2.02,.53-2.2,1.57-.16,.96,.43,1.89,1.37,2.15,1.37,.31,2.74,.65,4.13,.91,1.02,.23,2.03-.42,2.26-1.44,.23-1.02-.42-2.03-1.44-2.26"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerm2);
export default __webpack_public_path__ + "static/media/germ-2.f56f71492133a42e0a1ecf433062ee26.svg";
export { ForwardRef as ReactComponent };